// extracted by css-extract-rspack-plugin
export default {"subtitle":"XoeWzulVj0Uc6jTn__subtitle___","frameworkTimeline":"V59RHkW2sJQf35LJ__frameworkTimeline___"};